import {useContext, useMemo} from 'external/react'

import Public from 'context/public-context'

export default function usePublic() {

	const {state, update} = useContext(Public.Context)
    const {props: {navigation, params, query}, offers: {loading: loadingOffers, items: offers}, offersData} = state
    
    const offerData = useMemo(() => offersData[params.offerId] || {}, [params.offerId, offersData])

    const courseInDetails = useMemo(() =>
        params.courseId && state.courseDetails[params.courseId]
        ? state.courseDetails[params.courseId]
        : {}, [params.courseId, state.courseDetails])

    return {
        state,
        navigation,
        params,
        query,
        loadingOffers,
        offers,
        offerData,
        offersData,
        courseInDetails,
        update
    }

}